// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"993":"abe32c73","1581":"4c704d6b","1888":"7883bd26","4078":"cfc1c3a6"}[chunkId] + ".chunk.css";
};